import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_blue_header/estimate')({
  beforeLoad: () => {
    throw redirect({ to: '/devis', replace: true })
  },
})
